var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 161 112",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "wave-illustration"
  }, "Illustration einer Schallwelle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "wave-illustration"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "blue_bars"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.285269,117.364,42.8023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,30.979C46.826,24.208 45.143,18.71 43.07,18.71C40.997,18.71 39.314,24.208 39.314,30.979L39.314,59.023C39.314,65.795 40.997,71.292 43.07,71.292C45.143,71.292 46.826,65.795 46.826,59.023L46.826,30.979Z",
    style: {
      fill: "#00adef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.285269,103.364,42.8023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,30.979C46.826,24.208 45.143,18.71 43.07,18.71C40.997,18.71 39.314,24.208 39.314,30.979L39.314,59.023C39.314,65.795 40.997,71.292 43.07,71.292C45.143,71.292 46.826,65.795 46.826,59.023L46.826,30.979Z",
    style: {
      fill: "#00adef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.475448,89.3641,34.244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,26.072C46.826,22.009 45.143,18.71 43.07,18.71C40.997,18.71 39.314,22.009 39.314,26.072L39.314,63.931C39.314,67.994 40.997,71.292 43.07,71.292C45.143,71.292 46.826,67.994 46.826,63.931L46.826,26.072Z",
    style: {
      fill: "#00adef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.665627,75.3641,25.6857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,23.968C46.826,21.066 45.143,18.71 43.07,18.71C40.997,18.71 39.314,21.066 39.314,23.968L39.314,66.034C39.314,68.936 40.997,71.292 43.07,71.292C45.143,71.292 46.826,68.936 46.826,66.034L46.826,23.968Z",
    style: {
      fill: "#00adef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,1.04599,61.3641,8.56918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,22.056C46.826,20.209 45.143,18.71 43.07,18.71C40.997,18.71 39.314,20.209 39.314,22.056L39.314,67.946C39.314,69.793 40.997,71.292 43.07,71.292C45.143,71.292 46.826,69.793 46.826,67.946L46.826,22.056Z",
    style: {
      fill: "#00adef"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,1.8067,47.3641,-25.6639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,20.647C46.826,19.578 45.143,18.71 43.07,18.71C40.997,18.71 39.314,19.578 39.314,20.647L39.314,69.355C39.314,70.424 40.997,71.292 43.07,71.292C45.143,71.292 46.826,70.424 46.826,69.355L46.826,20.647Z",
    style: {
      fill: "#00adef"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "black_bars"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,2.1163,33.3641,-39.5963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,20.364C46.826,19.451 45.143,18.71 43.07,18.71C40.997,18.71 39.314,19.451 39.314,20.364L39.314,69.638C39.314,70.551 40.997,71.292 43.07,71.292C45.143,71.292 46.826,70.551 46.826,69.638L46.826,20.364Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,1.14108,19.3641,4.29004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,21.777C46.826,20.085 45.143,18.71 43.07,18.71C40.997,18.71 39.314,20.085 39.314,21.777L39.314,68.225C39.314,69.918 40.997,71.292 43.07,71.292C45.143,71.292 46.826,69.918 46.826,68.225L46.826,21.777Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.760717,5.36407,21.4066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,23.311C46.826,20.772 45.143,18.71 43.07,18.71C40.997,18.71 39.314,20.772 39.314,23.311L39.314,66.691C39.314,69.231 40.997,71.292 43.07,71.292C45.143,71.292 46.826,69.231 46.826,66.691L46.826,23.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.570538,-8.63593,29.9649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,24.845C46.826,21.459 45.143,18.71 43.07,18.71C40.997,18.71 39.314,21.459 39.314,24.845L39.314,65.158C39.314,68.543 40.997,71.292 43.07,71.292C45.143,71.292 46.826,68.543 46.826,65.158L46.826,24.845Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.380358,-22.6359,38.5231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,27.912C46.826,22.833 45.143,18.71 43.07,18.71C40.997,18.71 39.314,22.833 39.314,27.912L39.314,62.09C39.314,67.169 40.997,71.292 43.07,71.292C45.143,71.292 46.826,67.169 46.826,62.09L46.826,27.912Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.931878,0,0,0.380358,-36.6359,38.5231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.826,27.912C46.826,22.833 45.143,18.71 43.07,18.71C40.997,18.71 39.314,22.833 39.314,27.912L39.314,62.09C39.314,67.169 40.997,71.292 43.07,71.292C45.143,71.292 46.826,67.169 46.826,62.09L46.826,27.912Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveIllustration);
export default __webpack_public_path__ + "static/media/wave_illustration.d9ecf8f7.svg";
export { ForwardRef as ReactComponent };